export const inDevelopMode = process.env.REACT_APP_NODE_ENV === "development";
export const inProductionMode = process.env.REACT_APP_NODE_ENV === "production";
export const inLocalMode =
  process.env.REACT_APP_NODE_ENV !== "production" &&
  process.env.REACT_APP_NODE_ENV !== "development";


export const API_URL = process.env.REACT_APP_API_URL;

const currentHost =
  typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";

let apiHost = "";
try {
  apiHost = API_URL ? new URL(API_URL).hostname.toLowerCase() : "";
} catch {
  apiHost = "";
}

const matchesDomain = (value, domain) =>
  value === domain || value.endsWith(`.${domain}`);

export const isLive =
  matchesDomain(currentHost, "zd.propone.pk") ||
  matchesDomain(apiHost, "zd.propone.pk");

export const isTraining =
  matchesDomain(currentHost, "training.propone.pk") ||
  matchesDomain(apiHost, "training.propone.pk");


/**
 * Bayut/KSA staff portal hosts — live `bayutsa-one.propforce.com` and staging
 * `propone-bayutsa-zt.dubizzlelabs.run`. Matched on the shared `bayutsa`
 * marker, same as the tenant lookup in `configs/agency.js`.
 *
 * Deliberately host-based rather than keyed off REACT_APP_NODE_ENV: the Bayut
 * build ships with REACT_APP_NODE_ENV != "production", and setting it would
 * short-circuit getAgency() before its `bayutsa` check (see configs/agency.js).
 */
export const isBayutSa = currentHost.includes("bayutsa");
